<nb-checkbox class="form-field" [(ngModel)]="value" (change)="onChange($event)" [class.disabled]="disabled" >
  {{label}}
</nb-checkbox>
